
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 .5C3.875.5.5 3.875.5 8s3.375 7.5 7.5 7.5 7.5-3.375 7.5-7.5S12.125.5 8 .5zm2.662 10.35l-3.06-1.883a.74.74 0 01-.36-.637V4.812a.578.578 0 01.57-.562c.308 0 .563.255.563.563V8.15l2.88 1.732c.27.165.36.518.195.788a.577.577 0 01-.787.18z","fill":"#fff"}})])
          )
        }
      }
    